import { render, staticRenderFns } from "./previewRiskPopup.vue?vue&type=template&id=2c361a05"
import script from "./previewRiskPopup.vue?vue&type=script&lang=js"
export * from "./previewRiskPopup.vue?vue&type=script&lang=js"
import style0 from "./previewRiskPopup.vue?vue&type=style&index=0&id=2c361a05&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports